import routerOptions0 from "/usr/src/app/content/n3-redirections-legacy-13aa5902-bfc5-4b44-bdcf-bd87e873b45b/b2c-build/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}